// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { Person } from '../../SagaSchema/Person';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class MobPerson_abstract extends Person {
  static $t: string = 'SagaSchema.MobPerson';
  $t: string = 'SagaSchema.MobPerson';

  public static GetMembers(): string[] {
    return ['ResourcePriority', 'IsOptional'].concat(Person.GetMembers());
  }

  public GetMembers(): string[] {
    return MobPerson_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  components(): string[] {
    return ['SagaSchema.PhoneNumber', 'SagaSchema.ResAddress', 'SagaSchema.ResourceUriDocument'];
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ResourcePriority: number = 0;
  public IsOptional: boolean = true;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
